"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _llClient = _interopRequireDefault(require("ll-client"));

var _index = require("./index");

var _reducerUtil = _interopRequireDefault(require("../reducerUtil"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var config; //let logger;

var start = function start(configMap) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return dispatch(startLlClient(configMap));

            case 2:
              dispatch(startLogger());
              dispatch(setData(configMap));

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

var startLlClient = function startLlClient(configMap) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch) {
      var llyUrl, llyToken;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!config) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              llyUrl = process.env.REACT_APP_LAUNCH_LIGHTLY_URL;
              llyToken = process.env.REACT_APP_LAUNCH_LIGHTLY_TOKEN;
              config = new _llClient["default"]({
                endpoint: llyUrl,
                socketEndpoint: llyUrl,
                token: llyToken,
                initialConfig: dispatch(getInitialConfig(configMap))
              });
              config.connect();
              _context2.next = 8;
              return config.promise();

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};

var startLogger = function startLogger() {
  return function () {// if (logger) return;
    // logger = new smartbimLogger({ llclient: config }).getLogger();
    // window.onerror = (message, source, lineno, colno, error) => logger.error(error);
  };
};

var getInitialConfig = function getInitialConfig(configMap) {
  return function () {
    var initialConfig = {};
    Object.keys(configMap).forEach(function (groupKey) {
      return Object.keys(configMap[groupKey]).filter(function (itemKey) {
        return itemKey !== 'name';
      }).forEach(function (itemKey) {
        var key = configMap[groupKey][itemKey].key;
        var keyName = "REACT_APP_".concat(key);
        if (process.env[keyName]) initialConfig[key] = process.env[keyName];
      });
    });
    if (Object.keys(initialConfig).length > 0) return initialConfig;
  };
};

var setData = function setData(configMap) {
  return function (dispatch, getState) {
    if (!configMap) return;

    var data = _reducerUtil["default"].getSlice(_index.reducerData, _index.reducerData.data, getState());

    var newData = _objectSpread({}, data);

    Object.keys(configMap).forEach(function (group) {
      var groupData = {};
      Object.keys(configMap[group]).forEach(function (item) {
        if (item === 'name') return;
        groupData[configMap[group][item].name] = dispatch(llyData(configMap[group][item]));
      });
      newData[configMap[group].name] = groupData;
    });
    dispatch(_reducerUtil["default"].setSlice(_index.reducerData, _index.reducerData.data, newData));
  };
};

var llyData = function llyData(_ref3) {
  var key = _ref3.key,
      type = _ref3.type;
  return function () {
    switch (type) {
      case 'bool':
        return config.getBoolean(key);

      default:
        return config.getString(key);
    }
  };
};

var updateData = function updateData(configMap, groupName, itemName) {
  return function (dispatch, getState) {
    if (!configMap) throw new Error('A config map is required');
    if (!groupName) throw new Error('A group name is required');
    var group = Object.keys(configMap).find(function (key) {
      return configMap[key].name === groupName;
    });

    var data = _reducerUtil["default"].getSlice(_index.reducerData, _index.reducerData.data, getState());

    var newData = _objectSpread({}, data);

    if (!itemName) {
      var groupData = _objectSpread({}, newData[groupName]);

      Object.keys(configMap[group]).forEach(function (item) {
        if (item === 'name') return;
        groupData[configMap[group][item].name] = dispatch(llyData(configMap[group][item]));
      });
      newData[groupName] = groupData;
    } else {
      if (!newData[groupName]) newData[groupName] = {};
      var item = Object.keys(configMap[group]).find(function (key) {
        return configMap[group][key].name === itemName;
      });
      newData[groupName][itemName] = dispatch(llyData(configMap[group][item]));
    }

    dispatch(_reducerUtil["default"].setSlice(_index.reducerData, _index.reducerData.data, newData));
    if (!itemName) return newData[groupName];
    return newData[groupName][itemName];
  };
};

var getData = function getData(groupName, itemName) {
  return function (dispatch, getState) {
    if (!groupName) throw new Error('A group name is required');

    var data = _reducerUtil["default"].getSlice(_index.reducerData, _index.reducerData.data, getState());

    var _ref4 = data || {},
        searchGroup = _ref4[groupName];

    if (!itemName) return searchGroup || {};

    var _ref5 = searchGroup || {},
        searchItem = _ref5[itemName];

    return searchItem;
  };
};

var debug = function debug(message) {
  return function () {
    return console.debug(message);
  };
};

var info = function info(message) {
  return function () {
    return console.info(message);
  };
};

var error = function error(message) {
  return function () {
    return console.error(message);
  };
};

var _default = {
  start: start,
  updateData: updateData,
  getData: getData,
  debug: debug,
  info: info,
  error: error
};
exports["default"] = _default;